import { useCallback, useEffect, useRef, useState } from 'react';

import {
	Box,
	Heading,
	Table,
	TableContainer,
	Tbody,
	Td,
	Text,
	Th,
	Thead,
	Tr,
} from '@chakra-ui/react';
import Layout from '../../components/Layout/Layout';
import { getAllEncargos } from '../../services/encargos';
import { Link } from 'react-router-dom';
import EasyDatePicker from '../../components/EasyDatePicker/EasyDatePicker';
import FiltroEncargos from '../../components/Filtros/FiltroEncargos';

const ListarEncargos = () => {
	const [encargos, setEncargos] = useState([]);
	// const [encargosFiltrados, setEncargosFiltrados] = useState(encargos);
	// const [needReload, setNeedReload] = useState(true);

	const [page, setPage] = useState(1);
	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	// const [encargosFiltrados, setEncargosFiltrados] = useState([]);
	const [filtros, setFiltros] = useState({});

	const loaderRef = useRef(null);

	const loadMoreEncargos = useCallback(
		async (pagina, filtrosABuscar) => {
			if (loading || !hasMore) return;
			setLoading(true);
			try {
				const nuevosEncargos = await getAllEncargos(
					pagina,
					25,
					filtrosABuscar,
				);
				if (nuevosEncargos.length < 10) setHasMore(false);

				setEncargos(prevEncargos => [
					...prevEncargos,
					...nuevosEncargos,
				]);
				setPage(prevPage => prevPage + 1);
			} catch (error) {
				console.error('Error al cargar más encargos:', error);
				setHasMore(false);
			} finally {
				setLoading(false);
			}
		},
		[hasMore, loading],
	);

	const handleFiltros = ({ target }) => {
		const { value } = target;

		const newFilters = {
			...filtros,
			[target.name]: value,
		};

		setFiltros(newFilters);
		setEncargos([]);
		setPage(1);
		setHasMore(true);
		loadMoreEncargos(1, newFilters);
	};

	useEffect(() => {
		const observer = new IntersectionObserver(
			entries => {
				if (entries[0].isIntersecting && hasMore && !loading) {
					loadMoreEncargos(page, filtros);
				}
			},
			{
				threshold: 1.0,
			},
		);

		const currentLoader = loaderRef.current;
		if (currentLoader) {
			observer.observe(currentLoader);

			return () => {
				if (currentLoader) {
					observer.unobserve(currentLoader);
				}
			};
		}
	}, [loadMoreEncargos, hasMore, loading, page, filtros]);

	// useEffect(() => {
	// 	setEncargosFiltrados(encargos);
	// }, [encargos]);

	// useEffect(() => {
	// 	const getInmuebles = async () => {
	// 		setNeedReload(false);
	// 		const auxEncargos = await getAllEncargos();
	// 		setEncargos(auxEncargos);
	// 	};

	// 	needReload && getInmuebles();
	// }, [needReload]);

	return (
		<Layout>
			<Box mb={4}>
				<Heading textAlign='center' color='blue.800'>
					ENCARGOS
				</Heading>
			</Box>

			<FiltroEncargos setFiltros={handleFiltros} />

			<Box mt={6}>
				<TableContainer
					w='100%'
					border='1px'
					borderColor='blue.400'
					rounded='lg'
					shadow='md'
					overflowX='auto'
					overflowY='auto'
				>
					<Table
						size={{ base: 'sm', md: 'md', lg: 'lg' }}
						variant='simple'
						whiteSpace='nowrap'
					>
						<Thead bgColor='blue.100'>
							<Tr>
								<Th>Encargo</Th>
								<Th>Inmueble</Th>
								<Th>Propietario</Th>
								<Th>Motivo</Th>
								<Th>Precio</Th>
								<Th>Responsable</Th>
								<Th>Creación</Th>
								<Th>Modificación</Th>
							</Tr>
						</Thead>
						<Tbody>
							{encargos &&
								encargos.map(encargo => {
									let direccion = '';
									if (encargo.inmueble?.ubicacion) {
										try {
											direccion = JSON.parse(
												encargo.inmueble.ubicacion,
											).direccion;
										} catch (error) {
											direccion = JSON.parse(
												JSON.stringify(
													encargo.inmueble.ubicacion,
												),
											).direccion;
										}
									}
									return (
										<Tr
											key={encargo.uuid}
											h='100%'
											_hover={{
												cursor: 'pointer',
												bg: 'gray.100',
											}}
										>
											<TdLink encargo={encargo?.uuid}>
												EN - {encargo?.cliente?.nombre}{' '}
												{encargo.cliente?.apellidos} -{' '}
												{encargo?.estado}
											</TdLink>
											<TdLink encargo={encargo.uuid}>
												<strong>
													{
														encargo.inmueble
															?.tipo_inmueble
													}{' '}
													{
														encargo.inmueble
															?.subtipo_inmueble
													}
												</strong>{' '}
												en <strong>{direccion}</strong>
											</TdLink>
											<TdLink encargo={encargo.uuid}>
												{encargo.cliente?.nombre}{' '}
												{encargo.cliente?.apellidos}
											</TdLink>
											<TdLink encargo={encargo.uuid}>
												{encargo.noticia?.motivacion}
											</TdLink>
											<TdLink encargo={encargo.uuid}>
												{encargo.precio_final}
											</TdLink>
											<TdLink encargo={encargo.uuid}>
												{encargo.responsable?.nombre}{' '}
												{encargo.responsable?.apellidos}
											</TdLink>
											<TdLink encargo={encargo.uuid}>
												<EasyDatePicker
													value={encargo.createdAt}
													needHour={false}
												/>
											</TdLink>
											<TdLink encargo={encargo.uuid}>
												<EasyDatePicker
													value={encargo.updatedAt}
													needHour={false}
												/>
											</TdLink>
										</Tr>
									);
								})}
						</Tbody>
					</Table>
				</TableContainer>

				<Box ref={loaderRef} height='40px' />
				{loading && (
					<Text textAlign='center' mt={4}>
						Cargando...
					</Text>
				)}
				{!hasMore && (
					<Text textAlign='center' mt={4}>
						No hay más encargos para mostrar.
					</Text>
				)}
			</Box>
		</Layout>
	);
};

const TdLink = ({ children, encargo }) => {
	return (
		<Td>
			<Link to={`/encargos/ver/${encargo}`}>{children}</Link>
		</Td>
	);
};

export default ListarEncargos;
